import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Button } from 'reactstrap'
import './index.scss'

import masterProductOne from '../../assets/images/product/master_product_01.jpg'
import masterProductTwo from '../../assets/images/product/master_product_02.gif'

import videoGuideOne from '../../assets/video/review_01.mp4'
import videoGuideTwo from '../../assets/video/review_02.mp4'

const PrevArrow = (props) => {
  const { onClick } = props
  return (
    <div className="ch-arrow__left" onClick={onClick}>
      <FontAwesomeIcon icon="chevron-left" color="white" />
    </div>
  )
}

const NextArrow = (props) => {
  const { onClick } = props
  return (
    <div className="ch-arrow__right" onClick={onClick}>
      <FontAwesomeIcon icon="chevron-right" color="white" />
    </div>
  )
}

class Product extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [
        {
          title: 'สินค้าแนะนำ',
          subTitle: 'หอม อร่อย สดใหม่ พร้อมทาน',
          img: masterProductOne
        },
        {
          title: 'Hot Sale',
          subTitle: 'ไส้อั่ว/ไส้กรอกอีสาน เพ้งตี๋',
          img: masterProductTwo
        }
      ]
    }
    this.settings = {
      autoplay: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      lazyLoad: 'progressive',
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />
    }
  }
  render() {
    return (
      <div className="ch-product" id="product">
        <div className="container-fluid">
          <div className="row">
            <div className="ch-product-container">
              <div className="container-lg">
                <h1
                  className="display-4 text-center font-weight-bold"
                  data-aos="fade-up"
                  data-aos-duration="2000"
                >
                  <div className="text-icon">
                    <FontAwesomeIcon icon="hotdog" color="black" />
                  </div>
                  <span>สินค้า</span>
                </h1>
                <div className="row">
                  <div className="col-12">
                    <div
                      className="ch-product-slider"
                      data-aos="flip-down"
                      data-aos-duration="3000"
                    >
                      <Slider {...this.settings}>
                        {this.state.items.map((data, i) => {
                          return (
                            <Card className="ch-product-item" key={i}>
                              <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => this.props.history.push('/product-detail')}
                              >
                                <CardImg top width="100%" src={data.img} alt="chefhung-product" />
                              </div>
                              <CardBody>
                                <CardTitle className="text-primary font-weight-bold">
                                  <h2 className="m-0">{data.title}</h2>
                                </CardTitle>
                                <CardSubtitle className="text-secondary">
                                  <h5 className="m-0">{data.subTitle}</h5>
                                </CardSubtitle>
                                <CardText className="my-3"></CardText>
                                <Button
                                  color={'primary'}
                                  style={{ color: '#fff' }}
                                  onClick={() => this.props.history.push('/product-detail')}
                                >
                                  ดูรายละเอียด
                                </Button>
                              </CardBody>
                            </Card>
                          )
                        })}
                      </Slider>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-12 col-md-6 ch-video-box"
                    data-aos="fade-right"
                    data-aos-duration="2000"
                  >
                    <video width="100%" controls autoPlay muted loop playsInline>
                      <source src={videoGuideOne} type="video/mp4" />
                    </video>
                  </div>
                  <div
                    className="col-12 col-md-6 ch-video-box"
                    data-aos="fade-left"
                    data-aos-duration="2000"
                  >
                    <video width="100%" controls autoPlay muted loop playsInline>
                      <source src={videoGuideTwo} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Product)
